import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { MaskedLines, EASE } from "@/lib/motion";
import { SEO } from "@/components/site/SEO";

export default function ComingSoon() {
  const { pathname } = useLocation();
  const name = pathname.replace("/", "").replace(/-/g, " ") || "This page";
  const title = name.charAt(0).toUpperCase() + name.slice(1);

  return (
    <section data-testid="coming-soon-page" className="min-h-screen flex items-center bg-white">
      <SEO
        title={`${title} — Coming Soon`}
        description="This page is in progress at Upword Media. In the meantime, explore our services, case studies, or schedule a content audit."
        path={pathname}
        noindex
      />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 w-full">
        <p className="text-xs uppercase tracking-[0.25em] text-[#999999] mb-8 font-mono">Coming soon</p>
        <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl leading-[0.95] tracking-tight text-[#111111]">
          <MaskedLines lines={[title]} delay={0.1} />
          <span className="reveal-line">
            <motion.span className="block italic text-[#E0E0E0]" initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 0.9, ease: EASE, delay: 0.24 }}>
              in progress.
            </motion.span>
          </span>
        </h1>
        <p className="mt-8 max-w-xl text-lg text-[#666666] leading-relaxed">
          We&apos;re building this out in the next phase. In the meantime, explore our services or start a
          content audit — we move fast.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link to="/" data-testid="coming-soon-home" className="inline-flex items-center gap-2 bg-[#111111] text-white font-semibold px-8 py-4 hover:bg-[#333333] transition-colors group">
            <ArrowLeft size={17} className="transition-transform group-hover:-translate-x-1" /> Back Home
          </Link>
          <Link to="/contact" data-testid="coming-soon-contact" className="inline-flex items-center gap-2 border border-[#111111] text-[#111111] font-semibold px-8 py-4 hover:bg-[#F5F5F5] transition-colors">
            Schedule a Content Audit
          </Link>
        </div>
      </div>
    </section>
  );
}
